import i18n from '@/locales'

export default {
  data () {
    return {
      downloadId: '',
    }
  },
  created () {
    this.singleActions = [
      {
        label: i18n.t('scope.text_801'),
        action: (obj) => {
          this.download(obj)
        },
        meta: (obj) => {
          const ret = {
            validate: true,
          }
          if (obj.status !== 'available') {
            ret.validate = false
          }
          return ret
        },
      },
      {
        label: this.$t('common.action.delete'),
        action: (obj) => {
          this.createDialog('DeleteResDialog', {
            vm: this,
            data: [obj],
            columns: this.columns,
            title: this.$t('common.action.delete'),
            name: this.$t('common.offline_export'),
            onManager: this.onManager,
          })
        },
      },
    ]
  },
  methods: {
    async getDownloadUrl (params) {
      const { data } = await new this.$Manager('exportutils', 'v1').getSpecific({ id: 'download', spec: params.id, params: { direct: false } })
      let name = params.name || params.id
      if (params && params.format && !name.endsWith(params.format)) {
        name = name + '.' + params.format
      }
      return '/api/v1/exportutils/export/' + name + '?signature=' + data.signature
    },
    async download (params) {
      this.downloadId = params.id
      const path = await this.getDownloadUrl(params)
      this.$refs.exportButton.href = path
      this.$refs.exportButton.click()
    },
  },
}
